import { message } from "antd";
import { atom } from "jotai";
import { nanoid } from "nanoid";

// templates
const carePlanTemplate = {
  assessment: "",
  diagnosis: "",
  plan: "",
  evaluation: "",
  intervention: "",
};

const nursingNoteTemplate = {
  notes: "",
  consultationId: null,
};
const memberReferralTemplate = {
  id: null,
  referringDiagnosis: "",
  referralReason: "",
  presentingComplain: "",
  examinationFindings: "",
  investigationResults: "",
  treatmentGiven: "",

  patientId: null,
  referringOfficerId: null,
  sourceId: null,
  destinationId: null,
  consultationId: null,
};

const membershipRegistrationTemplate = {
  firstName: "",
  lastName: "",
  gender: "",
  contact: "",
  dob: null,
  amountPaid: 0,
  paymentType: "prepaid", // prepaid, postpaid
  email: "",
  location: "",
  term: "",
  startDate: "",
  membershipType: "primary",
  packageId: null,
};

const sponsoredMembersTemplate = {
  sponsorId: null,
};

const dependentRegistrationTemplate = {
  subscriberId: "",
  dependants: [],
  term: "TWELVE", // TWELVE, THREE
  defaultAmount: 0,
  defaultPackageId: null,
};

// state
const _carePlan = atom(carePlanTemplate);
const _nursingNote = atom(nursingNoteTemplate);
const _memberReferral = atom(memberReferralTemplate);
// const _otpCode = atom( '' );
const _membershipRegistration = atom(membershipRegistrationTemplate);
const _sponsoredMembers = atom([]);
const _dependentRegistration = atom(dependentRegistrationTemplate);

// atoms

// CAREPLAN
export const carePlanAtom = atom(
  (get) => get(_carePlan),
  (get, set, plan) => {
    set(_carePlan, { ...get(_carePlan), ...plan });
  }
);

export const clearCarePlanAtom = atom(null, (get, set, plan) => {
  set(_carePlan, carePlanTemplate);
});

// NURSING NOTES
export const nursingNoteAtom = atom(
  (get) => get(_nursingNote),
  (get, set, note) => {
    set(_nursingNote, { ...get(_nursingNote), ...note });
  }
);

export const clearNursingNoteAtom = atom(null, (get, set, note) => {
  set(_nursingNote, nursingNoteTemplate);
});

// export const otpCodeAtom = atom(
//     get => get( _otpCode ),
//     ( get, set, code ) => {
//         set( _otpCode, code );
//     }
// );

// REFERRAL
export const memberReferralAtom = atom(
  (get) => get(_memberReferral),
  (get, set, referral) => {
    set(_memberReferral, { ...get(_memberReferral), ...referral });
  }
);

export const clearRerralAtom = atom(null, (get, set, referral) => {
  set(_memberReferral, memberReferralTemplate);
});

// MEMBERSHIP REGISTRATION
export const membershipRegistrationAtom = atom(
  (get) => get(_membershipRegistration),
  (get, set, registration) => {
    set(_membershipRegistration, {
      ...get(_membershipRegistration),
      ...registration,
    });
  }
);

export const clearRegistrationAtom = atom(null, (get, set, registration) => {
  set(_membershipRegistration, membershipRegistrationTemplate);
});

// NEW SPONSORED MEMBERSHIP
export const getMembersAtom = atom((get) => get(_sponsoredMembers));

export const addMemberAtom = atom(null, (get, set, param) => {
  const memberData = param || {
    firstName: "",
    lastName: "",
    dob: null,
    gender: "",
    contact: "",
    amountPaid: 0,
    paymentType: "prepaid",
    email: "",
    term: "",
    startDate: "",
    packageId: null,
  };

  set(_sponsoredMembers, [
    ...get(_sponsoredMembers),
    {
      recordId: nanoid(),
      ...memberData,
    },
  ]);
});

export const deleteMemberAtom = atom(null, (get, set, recordId) => {
  set(
    _sponsoredMembers,
    get(_sponsoredMembers).filter((member) => member.recordId !== recordId)
  );
});

export const updateMemberAtom = atom(null, (get, set, params) => {
  let { recordId, field, value } = params;

  let item = get(_sponsoredMembers).find((pr) => pr.recordId === recordId);

  // if ( ( field === 'planId' ) && get( _sponsoredMembers ).find( itm => itm.planId === value ) ) {
  //     message.error( 'already selected!' );
  //     return;
  // }

  item[field] = value;
  set(
    _sponsoredMembers,
    get(_sponsoredMembers).map((itm) => {
      if (itm.recordId === recordId) return item;

      return itm;
    })
  );
});

export const resetSponsoredMembershipAtom = atom(null, (get, set, params) => {
  set(_sponsoredMembers, []);
});

// DEPENDENT REGISTRATION
export const dependentRegistrationAtom = atom(
  (get) => get(_dependentRegistration),
  (get, set, registration) => {
    set(_dependentRegistration, {
      ...get(_dependentRegistration),
      ...registration,
    });
  }
);

export const clearDependentRegistrationAtom = atom(
  null,
  (get, set, registration) => {
    set(_dependentRegistration, dependentRegistrationTemplate);
  }
);
